/**
 * Hooks for QMS requirement-level compliance (Phase 1).
 * Compliance % and gap report from standard_requirements.
 */

import { useState, useEffect, useCallback } from 'react';
import qmsComplianceService from '../services/qmsComplianceService';

export function useRequirementCompliance(organizationId, options = {}) {
  const [compliance, setCompliance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!organizationId) {
      setCompliance(null);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const data = await qmsComplianceService.getRequirementLevelCompliance(organizationId, options);
      setCompliance(data);
    } catch (err) {
      console.error('useRequirementCompliance:', err);
      setError(err.message);
      setCompliance(null);
    } finally {
      setLoading(false);
    }
  }, [organizationId, JSON.stringify(options)]);

  useEffect(() => {
    load();
  }, [load]);

  return { compliance, loading, error, refresh: load };
}

export function useGapReport(organizationId, options = {}) {
  const [gaps, setGaps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!organizationId) {
      setGaps([]);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const data = await qmsComplianceService.getGapReport(organizationId, options);
      setGaps(data);
    } catch (err) {
      console.error('useGapReport:', err);
      setError(err.message);
      setGaps([]);
    } finally {
      setLoading(false);
    }
  }, [organizationId, JSON.stringify(options)]);

  useEffect(() => {
    load();
  }, [load]);

  return { gaps, loading, error, refresh: load };
}
